import { render } from "./LoadingSpinnerNr7.vue?vue&type=template&id=55854d08&scoped=true"
import script from "./LoadingSpinnerNr7.vue?vue&type=script&lang=js"
export * from "./LoadingSpinnerNr7.vue?vue&type=script&lang=js"

import "./LoadingSpinnerNr7.vue?vue&type=style&index=0&id=55854d08&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55854d08"]])

export default __exports__